var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPromo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 680.764,
    height: 528.354,
    viewBox: "0 0 180.119 139.794",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.59 -66.639)",
    paintOrder: "fill markers stroke"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d0d0d0",
    d: "M13.591 66.639H193.71v139.794H13.591z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.507 133.514-34.249 34.249-15.968-15.968-41.938 41.937H178.726z",
    opacity: 0.675,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.217,
    cy: 108.555,
    r: 11.773,
    opacity: 0.675,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M26.111 77.634h152.614v116.099H26.111z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromo);
export default __webpack_public_path__ + "static/media/promo.ef65149d0731443b8253460c311db11a.svg";
export { ForwardRef as ReactComponent };